module.exports = __webpack_public_path__ + "img/p32.86cc8f04.png";